var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTruck = function SvgTruck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 32.45 46.4 14H33.56l-1 14h-2.15l-1.25-13.82a9 9 0 0 0-9-8.18H0v29.78l8.07 2a6 6 0 0 0 11.85.22h10.66a6 6 0 0 0 11.82 0h.6a4.88 4.88 0 0 0 3.61-1.57A5.28 5.28 0 0 0 48 32.45ZM45.25 24H40v-8h4.57ZM14 41a4 4 0 1 1 4-4 4 4 0 0 1-4 4Zm22.48 0a4 4 0 1 1 4-4 4 4 0 0 1-3.99 4Zm8.65-5.94A2.91 2.91 0 0 1 43 36h-.6a6 6 0 0 0-11.82 0H19.92a6 6 0 0 0-11.78-.25L2 34.22V8h18.19a7 7 0 0 1 7 6.37L28.59 30h5.84l1-14H38v10h7.43l.57 6.61a3.27 3.27 0 0 1-.86 2.45Z"
  })));
};
export default SvgTruck;